/* Pure helpers behind the state components (state system, 2026-09-04):
 * the lead sentence of a failed read and the page prefix of its reference.
 * Kept free of React so `npm run test:unit` can pin them. */

/** The reference the officer quotes is "<page>-<hex>": the page's rail
 * label folded to two letters, so support knows where it happened before
 * opening the log. Unknown names take their first two letters. */
const PREFIXES: Readonly<Record<string, string>> = {
  Today: 'td',
  Workbench: 'wb',
  Reconciliation: 'rc',
  Funds: 'fd',
  Documents: 'dc',
  'Manual entry': 'me',
  'Other operations': 'op',
  Tasks: 'tk',
  Proposals: 'pr',
  Admin: 'ad',
  Policy: 'pl',
  Users: 'us',
  Logins: 'lg',
  'System health': 'sh',
  'Extraction quality': 'eq',
  'Prompt optimization': 'po',
  'Chain review': 'cr',
  'Parked documents': 'pd',
}

export function pagePrefix(pageName: string): string {
  const hit = PREFIXES[pageName]
  if (hit) return hit
  const words = pageName
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.toLowerCase().replace(/[^a-z0-9]/g, ''))
    .filter(Boolean)
  if (words.length === 0) return 'pg'
  const two = words.length >= 2 ? words[0][0] + words[1][0] : words[0].slice(0, 2)
  return two.padEnd(2, 'x')
}

/** "The day sheet could not be loaded (HTTP 500)." — the plain sentence.
 * A status of 0 (no answer at all) says so instead of a code. */
export function errorLead(what: string, status: number | null): string {
  const noun = what.trim() || 'page'
  if (status === null) return `The ${noun} could not be loaded.`
  if (status > 0) return `The ${noun} could not be loaded (HTTP ${status}).`
  return `The ${noun} could not be loaded — no answer from the server.`
}
